// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorFulfillmentProviders = (client) => ({
    /**
     * `GET /vendor/fulfillment-providers`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListFulfillmentProviders
     * @source packages/modules/b2c-core/src/api/vendor/fulfillment-providers/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/fulfillment-providers", { method: "GET", query, headers }),
    /**
     * `GET /vendor/fulfillment-providers/:id/options`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListFulfillmentProviderOptions
     * @source packages/modules/b2c-core/src/api/vendor/fulfillment-providers/[id]/options/route.ts
     */
    listOptions: (id, query, headers) => client.fetch(buildPath("/vendor/fulfillment-providers/:id/options", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=fulfillment-providers.js.map